import React, { useEffect, useState } from "react";

const calc = (target) => {
  const diff = new Date(target).getTime() - Date.now();
  if (isNaN(diff) || diff <= 0) return { d: 0, h: 0, m: 0, s: 0 };
  return {
    d: Math.floor(diff / 86400000),
    h: Math.floor((diff / 3600000) % 24),
    m: Math.floor((diff / 60000) % 60),
    s: Math.floor((diff / 1000) % 60),
  };
};

export const CountdownTimer = ({ target, colors, scale = 1 }) => {
  const [t, setT] = useState(calc(target));
  useEffect(() => {
    const id = setInterval(() => setT(calc(target)), 1000);
    return () => clearInterval(id);
  }, [target]);

  const units = [
    { label: "DAYS", value: t.d },
    { label: "HOURS", value: t.h },
    { label: "MINS", value: t.m },
    { label: "SECS", value: t.s },
  ];

  return (
    <div className="grid grid-cols-4 gap-3 sm:gap-4 w-full max-w-md mx-auto" data-testid="countdown-timer">
      {units.map((u) => (
        <div
          key={u.label}
          className="flex flex-col items-center justify-center py-4 rounded-xl"
          style={{ border: `1px solid ${colors.primary}22`, background: "rgba(255,255,255,0.35)" }}
        >
          <span className="font-display" style={{ fontSize: 34 * scale, color: colors.text, lineHeight: 1 }}>
            {String(u.value).padStart(2, "0")}
          </span>
          <span className="font-body text-[10px] tracking-widest mt-2" style={{ color: colors.secondary }}>
            {u.label}
          </span>
        </div>
      ))}
    </div>
  );
};
